import {kvps, camelize, objectBy, setLocalStorage, checkLocalStorage} from 'src/utilities/utils'
import {ptracGetEntities} from 'src/utilities/ptracApi'
import {make} from 'vuex-pathify'
import {resetState} from 'src/utilities/vuex2'
import {OK} from 'http-status-codes'
import Constants from '@/utilities/constants'

const state = {
  ptracTask: [],
  job: []
}

const getters = make.getters(state)
const mutations = make.mutations(state)
mutations.reset = resetState

getters.jobLabel = (state) => (value) => {
  const priority = objectBy(state.job, 'value', value)
  if (priority) {
    return priority.label
  }
  return value
}
getters.taskLabel = (state) => (value) => {
  const priority = objectBy(state.ptracTask, 'value', value)
  if (priority) {
    return priority.label
  }
  return value
}

const _priorityStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchByEntityType({commit}, entityType) {
      if (checkLocalStorage(state, {enityType: camelize(entityType), module: Constants.LOCAL_STORAGE.LOCATION.PRIORITIES_DATA}, Constants.LOCAL_STORAGE.EXPIRATION.ONE_MONTH)) {
        return
      }

      const response = await ptracGetEntities('priorities/search/findByEntityTypeOrderBySortAsc?entityType=' + entityType)
      if (OK === response.status) {
        state[camelize(entityType)] = kvps(response.data, 'value', 'name')
        setLocalStorage(camelize(entityType) + Constants.LOCAL_STORAGE.LOCATION.PRIORITIES_DATA, state[camelize(entityType)])
      }
    }
  }
}

export { _priorityStore }
export default _priorityStore
